'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { REPORT_BUILDER_UPGRADE_LOCATIONS, REPORT_BUILDER_UPGRADE_KEYS } from 'dashboard-lib/public/upgradePointKeys';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportBuilderPql = props => {
  const {
    messageKey,
    preventEventPropagation = false,
    hideLockIcon = false,
    upgradeLocation
  } = props;
  const {
    openUpgradeModal
  } = useUpgradeModal(REPORT_BUILDER_UPGRADE_KEYS[upgradeLocation]);
  return /*#__PURE__*/_jsxs(Button, {
    "data-test-id": "report-action-edit-disabled",
    onClick: event => {
      openUpgradeModal();
      if (preventEventPropagation) {
        // preventEventPropagation should be set to true when the action is in a
        // dropdown to prevent the dropdown events from intercepting this button's events
        event.stopPropagation();
      }
    },
    use: "tertiary",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: messageKey
    }), !hideLockIcon && /*#__PURE__*/_jsx(LockBadge, {})]
  });
};
ReportBuilderPql.propTypes = {
  hideLockIcon: PropTypes.bool,
  messageKey: PropTypes.string.isRequired,
  preventEventPropagation: PropTypes.bool,
  upgradeLocation: PropTypes.oneOf(REPORT_BUILDER_UPGRADE_LOCATIONS).isRequired
};
export default ReportBuilderPql;